module.exports = __webpack_public_path__ + "img/ic_back.d9cef007.svg";